export const productsSliderOptions = (instance, options, maxItems) => {
    let responsiveItemCounts = {
        1024: 4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        cssMode: false,
        spaceBetween: 18,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}

export const productSectionSliderOptions = (instance, options, maxItems) => {
    let responsiveItemCounts = {
        1800: 3.4,
        1440: 2.4,
        1024: 1.8,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        cssMode: false,
        spaceBetween: 18,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}